import React from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Sparkles } from 'lucide-react';

const AGTEnhanceButton = ({
  onEnhance,
  isLoading,
  disabled = false,
  sx = {}
}) => {
  const theme = useTheme();
  const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

  return (
    <Tooltip
      title="Automatically enhance your profile descriptions using AI"
      arrow
      placement="top"
    >
      <span>
        <Button
          variant={isWallpaperMode ? "contained" : "outlined"}
          startIcon={isLoading ? <CircularProgress size={20} /> : <Sparkles size={20} />}
          onClick={onEnhance}
          disabled={disabled || isLoading}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: '28px',
            backgroundColor: isWallpaperMode ? '#FFFFFF' : 'transparent',
            color: isWallpaperMode ? '#000000' : '#0385FF',
            boxShadow: 'none',
            borderColor: isWallpaperMode ? 'transparent' : '#0385FF',
            '&:hover': {
              backgroundColor: isWallpaperMode
                ? 'rgba(255, 255, 255, 0.85)'
                : 'rgba(3,133,255,0.08)',
              boxShadow: 'none',
              borderColor: isWallpaperMode ? 'transparent' : '#0266cc'
            },
            ...sx
          }}
        >
          Enhance with AGT
        </Button>
      </span>
    </Tooltip>
  );
};

export default AGTEnhanceButton;
